import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import UploadFile from "../UploadFile";
import AlertMsg from "../AlertMsg";
import SwitchInput from "../SwitchInput";
import OrderTypeSelector from "../OrderTypeSelector";
import * as Api from "../../api";
import "../../assets/css/custom.css";
import {
  BTN_COLOR,
  BTN_TEXT_COLOR,
  THEME_COLOR3,
  THEME_COLOR4,
} from "../../constants";

const DAYS_LIST = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

const theme = createTheme({
  palette: {
    gray: {
      main: THEME_COLOR4,
    },
  },
});

const textInputCss = {
  "& .MuiInput-underline:before": {
    borderBottom: `1.5px solid ${THEME_COLOR4}`,
  },
  "& .MuiInput-underline:after": {
    borderBottom: `1.5px solid ${THEME_COLOR4}`,
  },
  "& .MuiInput-underline:hover:before": {
    borderBottom: 0,
  },
};

const AddSettingCategory = (props) => {
  const [nameVal, setNameVal] = useState("");
  const [descriptionVal, setDescriptionVal] = useState("");
  const [imageList, setImageList] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [categoryEnabled, setCategoryEnabled] = useState(false);
  const [excludedOrderTypes, setExcludedOrderTypes] = useState([]);
  const [availabilityRules, setAvailabilityRules] = useState([]);
  const [msgAlert, setMsgAlert] = useState({
    open: false,
    message: "",
    msgType: "error",
  });

  useEffect(() => {
    if (props.catData !== null) {
      const {
        name = "",
        description = "",
        images = [],
        enabled = false,
        excludedOrderTypes = [],
        availabilityRules = [],
      } = props.catData || {};
      setNameVal(name);
      setDescriptionVal(description);
      setImageList(images);
      setCategoryEnabled(enabled);
      setExcludedOrderTypes(excludedOrderTypes);
      setAvailabilityRules(availabilityRules);
    } else {
      setNameVal("");
      setDescriptionVal("");
      setImageList([]);
      setImageLoading(false);
      setBtnDisabled(false);
      setCategoryEnabled(true);
      setExcludedOrderTypes([]);
      setAvailabilityRules([]);
    }
  }, [props]);

  useEffect(() => {
    let upload_list = imageList.filter((x) => x.upload === false);
    if (upload_list.length > 0) {
      setImageLoading(true);
    } else {
      setImageLoading(false);
    }
  }, [imageList]);

  const onSubmit = (e) => {
    e.preventDefault();

    const catImageData = imageList.map((item, index) => item.name);
    const hasEmptyDaysRule = availabilityRules.some((rule) => !rule?.days || rule.days.length === 0);
    if (hasEmptyDaysRule) {
      setMsgAlert({
        open: true,
        message: "Please select at least one day for each availability rule",
        msgType: "error",
      });
      return;
    }

    const data1 = {
      name: nameVal,
      description: descriptionVal,
      _idRestaurant: props.restaurantId,
      images: catImageData,
      enabled: categoryEnabled,
      excludedOrderTypes: excludedOrderTypes,
      availabilityRules: availabilityRules,
    };
    const datas = JSON.stringify(data1);

    setBtnDisabled(true);
    if (props.catData === null) {
      Api.addMenuCategory(datas, props.restaurantId).then((response) => {
        if (response.success) {
          setMsgAlert({
            open: true,
            message: "Added Successfully",
            msgType: "success",
          });
          props.onSubmit();
        } else {
          setMsgAlert({ open: true, message: response.msg, msgType: "error" });
        }
        setBtnDisabled(false);
      });
    } else {
      Api.updateMenuCategory(datas, props.catData?._id, props.restaurantId).then((response) => {
        if (response.success) {
          setMsgAlert({
            open: true,
            message: "Updated Successfully",
            msgType: "success",
          });
          props.onSubmit();
        } else {
          setMsgAlert({ open: true, message: response.msg, msgType: "error" });
        }
        setBtnDisabled(false);
      });
    }
  };

  const onCloseAlertMsg = () => {
    setMsgAlert({ open: false, message: "", msgType: "error" });
  };

  const onRemoveImage = (data) => {
    setImageList([]);
    // let menuImage = [...imageList];
    // let imageIndex = menuImage.findIndex((item) => item.id == data.id);
    // if (imageIndex >= 0) {
    //   menuImage.splice(imageIndex, 1);
    //   setImageList(menuImage);
    // }
  };

  const uploadFile = (data, file) => {
    setImageList((prev) => [...prev, data]);
    setImageLoading(true);

    let formData = new FormData();
    formData.append("image", file);

    Api.uploadImageFile(formData).then((response) => {
      if (response.success) {
        data["name"] = response.data.fileId;
        data["image"] = response.data.location;
        data["upload"] = true;
        setImageList((prev) =>
          prev.map((el) => (el.id === data.id ? { ...el, ...data } : el))
        );
      } else {
        setMsgAlert({ open: true, message: response.msg, msgType: "error" });
      }
    });
  };

  const uploadError = (err) => {
    setMsgAlert({ open: true, message: err, msgType: "error" });
  };

  const handleOnChangeValue = (type, value) => {
    if (type === "name") {
      setNameVal(value);
    } else if (type === "description") {
      setDescriptionVal(value);
    }
  };

  const handlerCategoryEnabled = () => {
    setCategoryEnabled(!categoryEnabled);
  };

  const addAvailabilityRule = () => {
    setAvailabilityRules((prev) => [...prev, { days: [], from: "09:00", to: "21:00" }]);
  };

  const removeAvailabilityRule = (index) => {
    setAvailabilityRules((prev) => prev.filter((_, i) => i !== index));
  };

  const updateRuleDays = (index, day, checked) => {
    setAvailabilityRules((prev) =>
      prev.map((rule, i) => {
        if (i !== index) return rule;
        const currentDays = rule?.days || [];
        const days = checked
          ? [...currentDays, day]
          : currentDays.filter((d) => d !== day);
        return { ...rule, days };
      })
    );
  };

  const updateRuleTime = (index, field, value) => {
    setAvailabilityRules((prev) =>
      prev.map((rule, i) => (i === index ? { ...rule, [field]: value } : rule))
    );
  };

  return (
    <Grid
      component="form"
      onSubmit={onSubmit}
      container
      direction="column"
      sx={styles.mainGrid}
      // sx={{      flex: 1,
      //     flexDirection: "column",
      //     display: "flex",
      //     justifyContent: "flex-start", 
      //     minHeight: "100%",
      //     width: "100%",
      //     py: 1,
      //     px: 5,
    
      // }}
    >
      <Grid
        sx={{
          flex: 1,
          flexDirection: "column",
          display: "flex",
          justifyContent: "start",
        }}
      >
        <Grid>
          <Grid container direction="row" item xs={12}>
            <UploadFile
              page={"addResItemImg"}
              uploadText={"Drag and Drop Your Images Here"}
              maxFiles={1}
              imageLoading={imageLoading || btnDisabled}
              imageList={imageList}
              imageLength={imageList.length}
              onRemoveImage={onRemoveImage}
              uploadError={uploadError}
              uploadFile={uploadFile}
            />
          </Grid>

          <Grid item mt={3}>
            <Box sx={styles.enabledSwitchView}>
              <Typography sx={styles.enabledLabel}>Category Enabled</Typography>
              <SwitchInput
                checked={categoryEnabled}
                onChange={handlerCategoryEnabled}
              />
            </Box>
          </Grid>

          <Grid sx={{ mt: 3 }}>
            <Grid item sx={{ mb: 3 }}>
              <ThemeProvider theme={theme}>
                <TextField
                  required
                  focused
                  style={{ width: "100%" }}
                  value={nameVal}
                  color="gray"
                  id="categoryTitle"
                  label="Category Title"
                  variant="standard"
                  sx={textInputCss}
                  InputLabelProps={{
                    style: { color: THEME_COLOR3 },
                    sx: { ...styles.inputLabelText },
                  }}
                  inputProps={{
                    autoComplete: "none",
                    sx: { ...styles.inputText },
                  }}
                  onChange={(e) => handleOnChangeValue("name", e.target.value)}
                />
              </ThemeProvider>
            </Grid>
            <Grid item sx={{ mb: 3 }}>
              <ThemeProvider theme={theme}>
                <TextField
                  required
                  focused
                  style={{ width: "100%" }}
                  value={descriptionVal}
                  color="gray"
                  id="description"
                  label="Description"
                  variant="standard"
                  sx={textInputCss}
                  InputLabelProps={{
                    style: { color: THEME_COLOR3 },
                    sx: { ...styles.inputLabelText },
                  }}
                  inputProps={{
                    autoComplete: "none",
                    sx: { ...styles.inputText },
                  }}
                  onChange={(e) =>
                    handleOnChangeValue("description", e.target.value)
                  }
                />
              </ThemeProvider>
            </Grid>
            
            <Grid item sx={{ mb: 3 }}>
              <OrderTypeSelector
                selectedTypes={excludedOrderTypes}
                onChange={setExcludedOrderTypes}
                disabled={imageLoading || btnDisabled}
              />
            </Grid>

            <Grid item sx={{ mb: 3 }}>
              <Box sx={availabilityStyles.sectionHeader}>
                <Typography sx={availabilityStyles.sectionTitle}>Availability Rules</Typography>
                <Button
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={addAvailabilityRule}
                  disabled={imageLoading || btnDisabled}
                  sx={availabilityStyles.addButton}
                >
                  Add Rule
                </Button>
              </Box>
              <Typography sx={availabilityStyles.hint}>
                Leave empty to make this category always available.
              </Typography>
              {availabilityRules.map((rule, index) => (
                <Box key={index} sx={availabilityStyles.ruleRow}>
                  <Box sx={availabilityStyles.ruleContent}>
                    <Typography sx={availabilityStyles.daysLabel}>Days</Typography>
                    <Box sx={availabilityStyles.daysCheckboxGroup}>
                      {DAYS_LIST.map((day) => (
                        <FormControlLabel
                          key={day}
                          control={
                            <Checkbox
                              size="small"
                              checked={(rule?.days || []).includes(day)}
                              onChange={(e) => updateRuleDays(index, day, e.target.checked)}
                              disabled={imageLoading || btnDisabled}
                            />
                          }
                          label={<Typography sx={availabilityStyles.dayLabel}>{day.charAt(0).toUpperCase() + day.slice(1)}</Typography>}
                        />
                      ))}
                    </Box>
                    <Box sx={availabilityStyles.timeSection}>
                      <TextField
                        size="small"
                        label="Start Time"
                        type="time"
                        value={rule?.from || "09:00"}
                        onChange={(e) => updateRuleTime(index, "from", e.target.value)}
                        disabled={imageLoading || btnDisabled}
                        InputLabelProps={{ shrink: true }}
                        sx={availabilityStyles.timeField}
                      />
                      <TextField
                        size="small"
                        label="End Time"
                        type="time"
                        value={rule?.to || "21:00"}
                        onChange={(e) => updateRuleTime(index, "to", e.target.value)}
                        disabled={imageLoading || btnDisabled}
                        InputLabelProps={{ shrink: true }}
                        sx={availabilityStyles.timeField}
                      />
                    </Box>
                  </Box>
                  <IconButton
                    size="small"
                    onClick={() => removeAvailabilityRule(index)}
                    disabled={imageLoading || btnDisabled}
                    color="error"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" justifyContent="space-between">
        <Button
          type="button"
          disabled={imageLoading || btnDisabled}
          sx={styles.cancelBtn}
          onClick={props.onCancel}
        >
          Cancel
        </Button>
        <Button
          disabled={imageLoading || btnDisabled}
          type="submit"
          sx={styles.saveBtn}
        >
          {imageLoading || btnDisabled
            ? "Please Wait"
            : props.catData == null
            ? "Add Category"
            : "Update Category"}
        </Button>
      </Grid>
      <AlertMsg msgAlert={msgAlert} onCloseAlertMsg={onCloseAlertMsg} />
    </Grid>
  );
};

export default AddSettingCategory;

const styles = {
  mainGrid: {
    width: "100%",
    minHeight: "100%",
    py: 1,
    px: 5,
    flex: 1,
    flexDirection: "column",
    display: "flex",
    justifyContent: "flex-start",
  },
  enabledSwitchView: {
    display: "flex",
    alignItems: "center",
  },
  enabledLabel: {
    color: "#AAA",
    fontSize: 12,
    fontFamily: "GilroyRegular",
    mr: 1,
  },
  inputLabelText: {
    fontFamily: "GilroyRegular",
  },
  inputText: {
    fontSize: 13,
    fontFamily: "GilroySemiBold",
    my: 0.8,
  },
  cancelBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    textTransform: "capitalize",
    backgroundColor: "#FFF",
    color: "#000",
    fontFamily: "GilroyBold",
    fontSize: 14,
    borderRadius: 1,
    border: "2px solid #000000",
    width: "49%",
    height: 44,
    "&:hover": {
      backgroundColor: "#FFF !important",
    },
  },
  saveBtn: {
    backgroundColor: BTN_COLOR,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    textTransform: "capitalize",
    color: BTN_TEXT_COLOR,
    fontFamily: "GilroyBold",
    fontSize: 14,
    borderRadius: 1,
    width: "49%",
    height: 44,
    "&:hover": {
      backgroundColor: BTN_COLOR + " !important",
    },
  },
};

const availabilityStyles = {
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 0.5,
  },
  sectionTitle: {
    fontFamily: "GilroySemiBold",
    fontSize: 13,
    color: "#555",
  },
  addButton: {
    fontFamily: "GilroySemiBold",
    fontSize: 13,
    textTransform: "none",
    color: "#1a1a1a",
    border: "1px dashed #ccc",
  },
  hint: {
    fontFamily: "GilroyRegular",
    fontSize: 12,
    color: "#888",
    fontStyle: "italic",
    mb: 1.5,
  },
  ruleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    mb: 2,
    p: 2,
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#fafafa",
  },
  ruleContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  },
  daysLabel: {
    fontFamily: "GilroySemiBold",
    fontSize: 13,
    color: "#555",
  },
  daysCheckboxGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },
  dayLabel: {
    fontFamily: "GilroyRegular",
    fontSize: 13,
  },
  timeSection: {
    display: "flex",
    gap: 2,
    alignItems: "center",
  },
  timeField: {
    width: 160,
  },
};
